// Module
var code = "<div id=\"rubric-widget-numeric-element\" data-cy=\"numeric-element\" class=\"rb-scale rb-numeric rb-widget\"><div class=\"rb-label\" translate=\"rubric-widget-numeric_numeric-scale\"></div><div class=\"rb-avatar\"><ul class=\"unstyled\"><li>1</li><li>2</li><li>3</li><li>4</li><li>5</li></ul></div></div>";
// Exports
module.exports = code;